import { render, staticRenderFns } from "./LayoutExportacao.vue?vue&type=template&id=524ea9da&scoped=true"
import script from "./LayoutExportacao.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutExportacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LayoutExportacao.vue?vue&type=style&index=0&id=524ea9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524ea9da",
  null
  
)

export default component.exports